import React from "react";
import { Link } from "react-router-dom";
import { resolveImageUrl } from "../lib/images";

export default function ProductCard({ product }) {
    return (
        <Link
            to={`/producto/${product.id}`}
            className="group block bg-white rounded-xl overflow-hidden border border-border-soft/30 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgba(212,163,163,0.18)]"
            data-testid={`product-card-${product.id}`}
        >
            <div className="aspect-[4/5] bg-blush overflow-hidden">
                {product.images?.[0] ? (
                    <img
                        src={resolveImageUrl(product.images[0])}
                        alt={product.name}
                        className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-taupe text-xs">
                        Sin imagen
                    </div>
                )}
            </div>
            <div className="p-4 text-center">
                <p className="overline mb-1">{product.category}</p>
                <h3 className="font-serif text-xl text-charcoal leading-tight">
                    {product.name}
                </h3>
                <p className="mt-2 text-sm text-charcoal">${product.price.toFixed(2)}</p>
            </div>
        </Link>
    );
}
